require('./testimonials.scss');
require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

$(() => {
    const pageURL = $(location).attr("href");

    $('.slick-carousel').slick({
        infinite: false,
        slidesPerRow: 3,
        rows: 2,
        arrow: true,
        appendArrows: $('#slickArrows'),
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesPerRow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesPerRow: 1,
                }
            }
        ]
    });

    const maxHeight = 116; // Maximum height in pixels

    const readMore = (!pageURL.includes('/es/')) ? 'Read More' : 'Leer Mas';
    const readLess = (!pageURL.includes('/es/')) ? 'Read Less' : 'Leer Menos';

    $('.text-row').each(function (index) {
        let textWrapper = $(this);
        let textContent = textWrapper.find('p');
        // Check if text is truncated
        if (textContent[0].scrollHeight > maxHeight) {
            textWrapper.addClass('collapse');
            textWrapper.attr('aria-expanded', 'false');
            textWrapper.attr('id', 'collapse' + index);
            textWrapper.after(`<a role="button" class="expand-btn d-flex justify-content-center" data-bs-toggle="collapse" data-bs-target="#collapse${index}" aria-expanded="false" aria-controls="collapse${index}">${readMore}</a>`);
        }
        else {
            textWrapper.after(`<div class="filler"></div>`);
        }
    });
    $('.expand-btn').click(function () {
        if ($(this).text() === readMore) {
            $(this).text(readLess);
        } else {
            $(this).text(readMore);
        }
    });
})
;



